<template>
  <div class="question">
    <form class="question-container" @submit.prevent="send">
      <header class="question-header">
        <h2 class="question-title text-center">
          回答お疲れさまでした。
        </h2>
      </header>
      <div class="question-body">
        <div class="question-content">
          <p class="question-note">
            回答完了後「回答を送信して閉じる」押下をお願いいたします。<br />
            回答を中断したい場合は、<router-link :to="$wcRouter.path({ name: 'after-survey.index' })">
              施行後アンケート一覧
            </router-link>
            から、他の質問に回答できます。
          </p>
        </div>
        <footer class="question-footer">
          <WaveButton type="submit" :loading="loading">回答を送信して閉じる</WaveButton>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/api/after-survey'

export default {
  props: {
    afterSurveyId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      loading: false,
      errorMessage: '',
      revision: 0
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    }
  },

  methods: {
    async send() {
      this.errorMessage = ''
      this.loading = true

      try {
        await api.send(this.businessId, this.afterSurveyId)

        this.$emit('send')
      } catch(err) {
        this.$emit('error', err)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
